import { Module } from 'vuex'

// 由主应用 dataDashboard 通过 /api/func/comprehensive-analysis/dashboard/ 获取并传入的数据
export interface DashboardDataFromParent {
  consumption?: {
    total: number
    year: number
    month: number
    today: number
  }
  today_overview?: {
    eval_count: number
    eval_cost: number
    pre_count: number
    pre_cost: number
    contract_count: number
    contract_cost: number
  }
  business_overview?: {
    evaluations: number
    prequalifications: number
    contracts: number
    loans?: number
  }
  charts?: {
    pie: Array<{ name: string; value: number }>
    // 饼图专用响应省略首页热力图和趋势，消费方只读取实际展示的字段。
    heatmap?: number[][]
    trends?: {
      evaluation_trend: Array<{ date: string; count: number }>
      prequalification_trend: Array<{ date: string; count: number }>
    }
  }
}

interface ParentDataState {
  dashboardData: DashboardDataFromParent | null
}

const parentDataModule: Module<ParentDataState, any> = {
  namespaced: true,

  state: {
    dashboardData: null
  },

  mutations: {
    SET_DASHBOARD_DATA(state, data: DashboardDataFromParent | null) {
      state.dashboardData = data
    }
  },

  actions: {
    setDashboardData({ commit }, data: DashboardDataFromParent | null) {
      commit('SET_DASHBOARD_DATA', data)
    }
  },

  getters: {
    dashboardData: (state) => state.dashboardData
  }
}

export default parentDataModule
